<template>
  <div class="vx-col lg:w-1/2 w-full mb-base">
    <pulse-loader :loading="loading"></pulse-loader>
    <statistics-card-line
      :stats="stats"
      :icon="icon"
      type="area"
      v-if="!loading"
    />
  </div>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from "../../axios";
import { mapState } from "vuex";

export default {
  components: {
    StatisticsCardLine,
    PulseLoader
  },
  data() {
    return {
      stats: [],
      loading: false
    };
  },
  async mounted() {
    this.GetData();
    this.$store.watch(
      state => state.usageSettings.triggerNewData,
      this.GetData
    );
  },
  computed: { ...mapState(["customerStatus"]) },

  props: ["icon", "connectionId"],
  methods: {
    async GetData() {
      if (!this.customerStatus.has_smart_meter_points) {
        return;
      }

      if (
        this.$store.state.usageSettings.fromDate == null ||
        this.$store.state.usageSettings.toDate == null
      ) {
        return;
      }

      this.loading = true;
      try {
        let connectionResponse = await axios().get(
          `/api/connections/${this.connectionId}`
        );
        this.connection = connectionResponse.data;
        let trigger = this.$store.state.usageSettings.triggerNewData.trigger;
        trigger =
          trigger != null
            ? `&trigger=${this.$store.state.usageSettings.triggerNewData.trigger}`
            : null;
        let response = await axios().get(
          `/api/EnergyConsumption/cumulative?connectionId=${
            this.connectionId
          }&startDate=${this.$store.state.usageSettings.fromDate}&endDate=${
            this.$store.state.usageSettings.toDate
          }&typeUnity=${
            this.$store.state.usageSettings.unity
          }&intervalConsumption=${this.$store.state.usageSettings.interval}${
            trigger == null ? "" : trigger
          }`
        );
        this.stats = response.data;

        this.loading = false;
      } catch (error) {
        this.showError(
          "Er is iets misgegaan bij het ophalen van de meterstanden",
          false,
          error
        );
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
